"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurEducationalLegacy() {
  const {
    ref: portraitRef,
    isVisible: portraitVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: signatureRef,
    isVisible: signatureVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1186" id="our-educational-legacy" className="bg-background text-foreground relative overflow-hidden py-32 md:py-48" style={{
    backgroundColor: "hsl(40 20% 98%)"
  }}>
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.8'/></svg>\")"
    }} aria-hidden="true" />

      <div className="container mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-12">
          {}
          <div ref={portraitRef} className="lg:col-span-7 lg:pl-6" style={{
          transform: portraitVisible ? "translateY(0)" : "translateY(24px)",
          opacity: portraitVisible ? 1 : 0,
          transition: "transform 720ms cubic-bezier(.16, 1, 0.3, 1), opacity 720ms cubic-bezier(.16, 1, 0.3, 1)"
        }}>
            <div className="relative">
              {}
              <div className="relative p-3 md:p-4 rounded-md" style={{
              backgroundColor: "hsl(0 0% 100%)",
              boxShadow: "20px 20px 0px 0px hsl(0 75% 35% / 0.1)",
              borderLeft: "4px solid hsl(0 75% 35%)"
            }}>
                <div className="relative overflow-hidden">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/african_business_leaders_collaboration.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/african_business_leaders_collaboration.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/african_business_leaders_collaboration.webp-wvc-sizes" alt="Executives collaborating in a modern African business environment" className="block h-auto w-full object-cover" style={{
                  aspectRatio: "4 / 5",
                  filter: "contrast(1.05) saturate(0.9)"
                }} loading="lazy" decoding="async" />
                </div>
              </div>

              {}
              <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] md:text-[0.75rem]" style={{
              color: "hsl(220 10% 45%)"
            }}>
                — ABIS Campus · Accra, 2024
              </p>
            </div>
          </div>

          {}
          <div className="relative lg:col-span-5">
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -top-8 left-0 select-none font-serif leading-none" style={{
            fontSize: "clamp(11rem, 22vw, 26rem)",
            color: "transparent",
            WebkitTextStroke: "2px hsl(0 75% 35%)",
            opacity: 0.05,
            fontWeight: 400,
            transform: portraitVisible ? "translateY(-6%)" : "translateY(0)",
            transition: "transform 1200ms cubic-bezier(.16, 1, 0.3, 1)"
          }}>
              01
            </div>

            <div className="relative">
              {}
              <div ref={eyebrowRef} className="font-mono text-xs uppercase tracking-[0.2em] md:text-[0.75rem]" style={{
              color: "hsl(0 75% 35%)",
              opacity: eyebrowVisible ? 1 : 0,
              transform: eyebrowVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.16, 1, 0.3, 1), opacity 720ms cubic-bezier(.16, 1, 0.3, 1)"
            }}>ABOUT US</div>

              {}
              <h2 ref={headlineRef} className="mt-6 font-default font-normal leading-[1.1]" style={{
              fontSize: "clamp(2.25rem, 5vw, 3.5rem)",
              letterSpacing: "-0.02em",
              color: "hsl(220 15% 5%)",
              opacity: headlineVisible ? 1 : 0,
              transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.16, 1, 0.3, 1) 90ms, opacity 720ms cubic-bezier(.16, 1, 0.3, 1) 90ms"
            }}>
                Our Educational{" "}
                <em className="italic font-serif" style={{
                color: "hsl(0 75% 35%)",
                opacity: headlineVisible ? 1 : 0,
                transform: headlineVisible ? "translateY(0)" : "translateY(8px)",
                transition: "transform 600ms cubic-bezier(.16, 1, 0.3, 1) 290ms, opacity 600ms cubic-bezier(.16, 1, 0.3, 1) 290ms",
                display: "inline-block"
              }}>
                  Legacy
                </em>
              </h2>

              {}
              <div ref={paragraphRef} style={{
              opacity: paragraphVisible ? 1 : 0,
              transform: paragraphVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.16, 1, 0.3, 1) 180ms, opacity 720ms cubic-bezier(.16, 1, 0.3, 1) 180ms"
            }}>
                <p className="mt-8 max-w-[42ch] font-default text-base leading-[1.6] md:text-lg" style={{
                color: "hsl(220 10% 45%)"
              }}>
                  Africa Business and Innovation School is a forward-thinking institution dedicated to equipping professionals, entrepreneurs, and organizations with the skills needed to thrive in today’s dynamic business environment.
                </p>
                <p className="mt-8 max-w-[42ch] font-default text-base leading-[1.6] md:text-lg" style={{
                color: "hsl(220 10% 45%)"
              }}>
                  We specialize in practical, high-impact training in areas such as Artificial Intelligence, Strategic Communication, Leadership, and Marketing, designed to drive productivity, innovation, and sustainable growth.
                </p>
                <p className="mt-8 max-w-[42ch] font-default text-base leading-[1.6] md:text-lg" style={{
                color: "hsl(220 10% 45%)"
              }}>
                  Our approach combines real-world application, modern tools, and expert-led learning to empower individuals and organizations to compete effectively in a rapidly evolving global economy.
                </p>

                <h3 className="mt-12 font-default text-lg font-bold uppercase tracking-wider" style={{
                color: "hsl(220 15% 5%)"
              }}>
                  OUR MISSION
                </h3>
                <p className="mt-4 max-w-[42ch] font-default text-base leading-[1.6]" style={{
                color: "hsl(220 10% 45%)"
              }}>
                  To empower individuals and organizations with innovative skills, practical knowledge, and transformative tools that drive business excellence and sustainable development across Africa.
                </p>

                <h3 className="mt-12 font-default text-lg font-bold uppercase tracking-wider" style={{
                color: "hsl(220 15% 5%)"
              }}>
                  OUR VISION
                </h3>
                <p className="mt-4 max-w-[42ch] font-default text-base leading-[1.6]" style={{
                color: "hsl(220 10% 45%)"
              }}>
                  To become a leading hub for business innovation and professional development in Africa, shaping a new generation of leaders equipped to transform industries and economies.
                </p>
              </div>

              {}
              <div ref={signatureRef} className="mt-12" style={{
              opacity: signatureVisible ? 1 : 0,
              transform: signatureVisible ? "translateY(0)" : "translateY(24px)",
              transition: "transform 720ms cubic-bezier(.16, 1, 0.3, 1) 270ms, opacity 720ms cubic-bezier(.16, 1, 0.3, 1) 270ms"
            }}>
                <div className="inline-block">
                  <div className="font-serif italic" style={{
                  fontSize: "1.75rem",
                  color: "hsl(220 15% 5%)",
                  letterSpacing: "-0.01em"
                }}>Mr. Prince Ntiamoah Boampong</div>
                  <svg className="mt-1 h-3 w-44" viewBox="0 0 180 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M2 7 C 30 2, 60 11, 90 6 S 150 3, 178 8" stroke="hsl(0 100% 50%)" strokeWidth="1.5" strokeLinecap="round" fill="none" />
                  </svg>
                  <div className="mt-2 font-mono text-[0.7rem] uppercase tracking-[0.2em]" style={{
                  color: "hsl(0 75% 35%)"
                }}>
                    Academic Dean · Visionary Leader
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}